module.exports = __webpack_public_path__ + "img/Hilltop_Grill@2x.484a9fee.png";